var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophoneOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.271,
    height: 16,
    viewBox: "0 0 11.271 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(-648 -749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mic",
    d: "M2.818,16a1,1,0,0,1,0-2H4.7V12.91A5.908,5.908,0,0,1,0,7,.972.972,0,0,1,.94,6a.972.972,0,0,1,.939,1,3.888,3.888,0,0,0,3.756,4A3.888,3.888,0,0,0,9.393,7a.941.941,0,1,1,1.878,0,5.908,5.908,0,0,1-4.7,5.909V14H8.453a1,1,0,0,1,0,2Zm0-9V3A2.916,2.916,0,0,1,5.635,0,2.916,2.916,0,0,1,8.453,3V7a2.916,2.916,0,0,1-2.817,3A2.916,2.916,0,0,1,2.818,7ZM4.7,3V7a.972.972,0,0,0,.939,1,.972.972,0,0,0,.939-1V3a.972.972,0,0,0-.939-1A.972.972,0,0,0,4.7,3Z",
    transform: "translate(648 749)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphone-off.2e5eb20bbdadee2f28e4f0a6775f40ea.svg";
export { ForwardRef as ReactComponent };